import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkeletonComponent } from './skeleton.component';
import { SkeletonListComponent } from 'components/skeleton/skeleton-list.component';
import { SkeletonBaseComponent } from 'components/skeleton/skeleton-base.component';
import { FcpSkeletonComponent } from './fcp-skeleton.component';
import { FcpSkeletonListComponent } from './fcp-skeleton-list.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
        FcpSkeletonComponent,
        FcpSkeletonListComponent,
        SkeletonComponent,
        SkeletonListComponent,
        SkeletonBaseComponent
    ],
    exports: [FcpSkeletonComponent, FcpSkeletonListComponent, SkeletonComponent, SkeletonListComponent]
})
export class SkeletonModule {}
